import React, { useRef } from 'react';
import { Motion, spring } from 'react-motion';
import { useResizeObserverState } from '../../../../../../../hooks/useResizeObserverState';
import { useStateSelector } from '../../stateManager';
import { createIsExpandedRowSelector } from '../../utils/selectors';
import styles from './index.module.scss';

const ExpandedContainer = ({ rowId, children }) => {
  const selectIsExpanded = createIsExpandedRowSelector(rowId);
  const expanded = useStateSelector(selectIsExpanded);

  const nodeRef = useRef(null);

  const height = useResizeObserverState(nodeRef, {
    compute: (el) => el?.scrollHeight,
    enabled: expanded,
    defaultValue: 0,
  });

  return (
    <Motion style={createMotionStyle(expanded, height)}>
      {({ height: h, opacity: o }) => (
        <div
          ref={nodeRef}
          className={styles.root}
          style={{
            opacity: o,
            height: h,
            pointerEvents: expanded ? 'auto' : 'none',
          }}
        >
          {children}
        </div>
      )}
    </Motion>
  );
};

export default ExpandedContainer;

function createMotionStyle(isExpanded, measuredHeight) {
  return {
    height: spring(isExpanded ? measuredHeight : 0, {
      stiffness: 260,
      damping: 30,
    }),
    opacity: spring(isExpanded ? 1 : 0, { stiffness: 260, damping: 30 }),
  };
}
